(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4140],{

/***/ 33603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ getTransitionName; }
/* harmony export */ });
/* harmony import */ var _config_provider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53124);

// ================== Collapse Motion ==================
const getCollapsedHeight = () => ({
  height: 0,
  opacity: 0
});
const getRealHeight = node => {
  const {
    scrollHeight
  } = node;
  return {
    height: scrollHeight,
    opacity: 1
  };
};
const getCurrentHeight = node => ({
  height: node ? node.offsetHeight : 0
});
const skipOpacityTransition = (_, event) => (event === null || event === void 0 ? void 0 : event.deadline) === true || event.propertyName === 'height';
const initCollapseMotion = (rootCls = _config_provider__WEBPACK_IMPORTED_MODULE_0__/* .defaultPrefixCls */ .Rf) => ({
  motionName: `${rootCls}-motion-collapse`,
  onAppearStart: getCollapsedHeight,
  onEnterStart: getCollapsedHeight,
  onAppearActive: getRealHeight,
  onEnterActive: getRealHeight,
  onLeaveStart: getCurrentHeight,
  onLeaveActive: getCollapsedHeight,
  onAppearEnd: skipOpacityTransition,
  onEnterEnd: skipOpacityTransition,
  onLeaveEnd: skipOpacityTransition,
  motionDeadline: 500
});
const _SelectPlacements = (/* unused pure expression or super */ null && (['bottomLeft', 'bottomRight', 'topLeft', 'topRight']));
const getTransitionName = (rootPrefixCls, motion, transitionName) => {
  if (transitionName !== undefined) {
    return transitionName;
  }
  return `${rootPrefixCls}-${motion}`;
};

/* harmony default export */ __webpack_exports__["Z"] = (initCollapseMotion);

/***/ }),

/***/ 19384:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ios/extreme-verification",
      function () {
        return __webpack_require__(36085);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61906);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2261);
/* harmony import */ var swiper_modules__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66832);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4839);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24576);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89995);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_8__);









// 备份提示步骤集合
const backupArr = [
    {
        url: "/images/ios-backup/step1.webp",
        alt: "backup-step1",
        width: "229px",
        height: "379px",
        mbWidth: "229px",
        mbHeight: "379px",
        text: "Open the Settings of the target device and click on the account name"
    },
    {
        url: "/images/ios-backup/step2.webp",
        alt: "backup-step2",
        width: "229px",
        height: "379px",
        mbWidth: "229px",
        mbHeight: "379px",
        text: "Tap iCloud"
    },
    {
        url: "/images/ios-backup/step3.webp",
        alt: "backup-step3",
        width: "229px",
        height: "379px",
        mbWidth: "229px",
        mbHeight: "379px",
        text: "Select iCloud Backup"
    },
    {
        url: "/images/ios-backup/step4.webp",
        alt: "backup-step4",
        width: "229px",
        height: "379px",
        mbWidth: "229px",
        mbHeight: "379px",
        text: "Tap the slider next to iCloud Backup If its green youll know youve turned on iCloud backup and you can skip to the next step"
    },
    {
        url: "/images/ios-backup/step5.webp",
        alt: "backup-step5",
        width: "229px",
        height: "379px",
        mbWidth: "229px",
        mbHeight: "379px",
        text: "Make sure to enable syncing for all the apps you want to monitor"
    },
    {
        url: "/images/ios-backup/step6.webp",
        alt: "backup-step6",
        width: "371px",
        height: "379px",
        mbWidth: "325px",
        mbHeight: "332px",
        text: "Finally click Back Up Now Wait until the backup process complete While your iPhone is backing up your data You must remain connected to Wi-Fi"
    },
    {
        url: "/images/ios-backup/step7.webp",
        alt: "backup-step7",
        width: "421px",
        height: "379px",
        mbWidth: "325px",
        mbHeight: "293px",
        text: "Make sure there is enough storage left in the target iCloud account When the iCloud is full you can only see the previous backup data if you wanna view more data you can consider upgrading the iCloud storage plan"
    },
    {
        url: "/images/ios-backup/step8.png",
        alt: "backup-step8",
        width: "180px",
        height: "379px",
        mbWidth: "180px",
        mbHeight: "379px",
        text: "Turn on the Access iCloud Data on Web toggle"
    }
];
const StepProgress = (param)=>{
    let { current , total  } = param;
    const barWidth = 72; //宽度
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex items-center gap-4 mb-[40px] Mlg:mb-[20px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-[20px] leading-[30px] font-medium text-[#484B60] Mlg:text-[16px] Mlg:leading-[24px] ",
                children: [
                    current,
                    "/",
                    total
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex gap-x-[6px]",
                children: Array.from({
                    length: total
                }).map((_, i)=>{
                    const active = i < current;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-[4px] w-[72px] Mlg:w-[51.8px] rounded-[1px]",
                        style: active ? {
                            background: "linear-gradient(90deg, #09A6EA 1.56%, #6838F2 47.99%)",
                            backgroundSize: "".concat(current * barWidth, "px 4px"),
                            backgroundPosition: "-".concat(i * barWidth, "px 0px")
                        } : {
                            background: "#E8EDFF"
                        }
                    }, i);
                })
            })
        ]
    });
};
const Backup = (param)=>{
    let { setJustVerified2  } = param;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("common");
    const [current, setCurrent] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0) // 当前的步骤
    ;
    const [innerWidth, setInnerWidth] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0) // 实时屏幕宽度
    ;
    const prevRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null) // 上一步按钮
    ;
    const nextRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null) // 下一步按钮
    ;
    const paginationRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null) // 圆点导航按钮
    ;
    // 监听屏幕宽度
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (true) {
            const handlerInnerWidth = ()=>{
                setInnerWidth(window.innerWidth);
            };
            handlerInnerWidth();
            window.addEventListener("resize", handlerInnerWidth);
            return ()=>{
                window.removeEventListener("resize", handlerInnerWidth);
            };
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full max-w-[648px] h-max px-[10px] flex flex-col items-center relative Mlg:pb-[75px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StepProgress, {
                current: 5,
                total: 5
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                src: "/images/apps/apple.svg",
                alt: "img",
                className: "w-[60px] h-[69px] Mlg:w-[35px] Mlg:h-[40px]",
                style: {
                    opacity: current === backupArr.length ? "0" : "100"
                },
                width: "60",
                height: "69"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "w-full max-w-[420px] mt-[24px] text-[30px] Mlg:text-[20px] text-[#2405F2] text-center font-[600] leading-[40px] Mlg:leading-[30px]",
                style: {
                    opacity: current === backupArr.length ? "0" : "100"
                },
                children: t("Turn on the iCloud Backup")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-max max-w-full my-[16px] flex items-start justify-center text-[14px] Mlg:text-[10px] text-[#F11E34] leading-[21px] Mlg:leading-[15px] p-[8px_18px_8px_16px] Mlg:p-[14px_17px_11px] bg-[#FF00000D] rounded-[6px]",
                style: {
                    opacity: current === backupArr.length ? "0" : "100"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: "/images/apps/waring.svg",
                        className: "flex items-start mt-[5px] Mlg:mt-[3px] mr-[6px]",
                        alt: "img",
                        width: 12,
                        height: 12
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-center",
                        children: t("You can only get all data if iCloud is turned on")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .Swiper */ .tq, {
                modules: [
                    swiper_modules__WEBPACK_IMPORTED_MODULE_5__/* .Navigation */ .W_,
                    swiper_modules__WEBPACK_IMPORTED_MODULE_5__/* .Pagination */ .tl
                ],
                direction: "horizontal",
                allowTouchMove: false,
                navigation: {
                    prevEl: prevRef.current,
                    nextEl: nextRef.current
                },
                onBeforeInit: (swiper)=>{
                    swiper.params.navigation.prevEl = prevRef.current;
                    swiper.params.navigation.nextEl = nextRef.current;
                    swiper.params.pagination.el = paginationRef.current;
                    swiper.params.pagination.renderBullet = (_, className)=>'<div class="'.concat(className, ' myBullet"></div>');
                },
                pagination: {
                    clickable: true,
                    el: paginationRef.current,
                    renderBullet: (_, className)=>{
                        return '<div class="'.concat(className, ' myBullet"></div>');
                    }
                },
                onSlideChange: (swiper)=>{
                    setCurrent(swiper.realIndex);
                },
                className: "w-full max-w-[500px] relative",
                style: {
                    top: current === backupArr.length ? "-122px" : "0px"
                },
                children: [
                    backupArr.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .SwiperSlide */ .o5, {
                            className: "h-full flex flex-col justify-center items-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "h-[379px] mb-[48px] flex justify-center items-center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: item.url,
                                        alt: item.alt,
                                        width: 100,
                                        height: 100,
                                        style: {
                                            width: innerWidth > 768 ? item.width : item.mbWidth,
                                            height: innerWidth > 768 ? item.height : item.mbHeight
                                        },
                                        className: "object-cover object-left-top [box-shadow:0px_4px_18px_0px_#00000033] select-none"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "w-full text-[14px] text-[#000000] text-center leading-[22px]",
                                    children: t(item.text)
                                })
                            ]
                        }, index)),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        ref: paginationRef,
                        className: "!h-[8px] flex justify-center items-center gap-x-[5px] absolute !top-[403px] !left-[50%] !-translate-x-[50%] z-20 ".concat(current === backupArr.length ? "hidden" : "")
                    })
                ]
            }, innerWidth <= 768 ? "mobile" : "desktop"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full mx-auto fixed bottom-0 left-[150px] Mlg:left-0 right-0 bg-white border-t-[1px] border-[#E5E7EB] z-[1]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex justify-center w-full p-5 Mlg:px-0 bg-white mx-auto",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "w-full lg:w-[620px] flex justify-between smj:px-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                ref: prevRef,
                                className: "border-[1px] border-[#454CFF] bg-white rounded-[24px] h-[35px] flex items-center pl-[10px] pr-[19px] ".concat(current == 0 && "opacity-0"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        className: "mr-[7px]",
                                        src: "/images/bind/bind-arrow-blue.svg",
                                        width: 18,
                                        height: 18,
                                        alt: "back"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-[15px] text-[#454CFF] font-[600]",
                                        children: t("BACK")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                ref: nextRef,
                                className: "bg-[#FFCF55] rounded-[24px] h-[35px] flex items-center pl-[24px] pr-[10px] ".concat(current == backupArr.length - 1 && "hidden"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-[15px] text-[#1B1C2B] font-[600]",
                                        children: t("NEXT")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        className: "ml-[6px]",
                                        src: "/images/bind/bind-arrow-black.svg",
                                        width: 18,
                                        height: 18,
                                        alt: "back"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                onClick: ()=>{
                                    if (current == backupArr.length - 1) setJustVerified2(true);
                                },
                                className: "bg-[#FFCF55] rounded-[24px] h-[35px] flex items-center pl-[24px] pr-[10px] ".concat(current == backupArr.length - 1 || "hidden"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-[15px] text-[#1B1C2B] font-[600]",
                                        children: t("NEXT")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        className: "ml-[6px]",
                                        src: "/images/bind/bind-arrow-black.svg",
                                        width: 18,
                                        height: 18,
                                        alt: "back"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Backup);


/***/ }),

/***/ 7595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ MessageInfo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2453);


const MessageInfo = (param)=>{
    const key = Date.now();
    const isObject = param && typeof param === "object" && !Array.isArray(param);
    const type = (isObject ? param.type : null) || "remind";
    const duration = (isObject ? param.duration : null) || 3;
    const src = type === "success" ? "/image/success.svg" : type === "error" ? "/image/error.svg" : type === "warn" ? "/image/warn.svg" : "/image/remind.svg";
    var _content;
    const text = isObject ? (_content = param.content) !== null && _content !== void 0 ? _content : "" : param;
    const content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "max-w-[340px] w-full flex items-center gap-x-[12px]",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: src,
                alt: "",
                width: 24,
                height: 24
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "text-[14px] leading-[22px] text-[#484B60]",
                children: text
            })
        ]
    });
    antd__WEBPACK_IMPORTED_MODULE_1__/* ["default"].open */ .ZP.open({
        content,
        key,
        duration
    });
};



/***/ }),

/***/ 36085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ extreme_verification; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/utils/i18n.js + 1 modules
var i18n = __webpack_require__(61906);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 14 modules
var input = __webpack_require__(96456);
// EXTERNAL MODULE: ./node_modules/antd/es/spin/index.js + 5 modules
var spin = __webpack_require__(57381);
// EXTERNAL MODULE: ./node_modules/antd/es/select/index.js + 40 modules
var es_select = __webpack_require__(13573);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
;// CONCATENATED MODULE: ./src/components/ios-extreme/extreme-verfiy2/style.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex-wrap: wrap;\n\n    .ant-select .ant-select-selector {\n        height: 100%;\n        display: flex;\n        align-items: center;\n        border: none;\n        border-radius: 26px;\n        background: #F5F6F7;\n        box-shadow: none !important;\n    }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}

const ExtremeVerfiyCommponents = styled_components_browser_esm/* default.div */.ZP.div(_templateObject());
/* harmony default export */ var style = (ExtremeVerfiyCommponents);

// EXTERNAL MODULE: ./src/@api/login.js + 1 modules
var login = __webpack_require__(53399);
// EXTERNAL MODULE: ./src/utils/updateDeviceCredentials.js
var updateDeviceCredentials = __webpack_require__(80122);
// EXTERNAL MODULE: ./src/utils/resolveCurrentOrderId.js
var resolveCurrentOrderId = __webpack_require__(32870);
// EXTERNAL MODULE: ./src/components/pop-up-window/index.js
var pop_up_window = __webpack_require__(7595);
// EXTERNAL MODULE: ./src/components/Message/index.js + 1 modules
var Message = __webpack_require__(29143);
// EXTERNAL MODULE: ./src/store/apps/Common/index.js
var Common = __webpack_require__(34745);
// EXTERNAL MODULE: ./src/components/ios-extreme/icloud-locked/useIcloudLockedFlow.js + 3 modules
var useIcloudLockedFlow = __webpack_require__(82000);
// EXTERNAL MODULE: ./src/components/ios-extreme/icloud-locked/useIcloudCredentialReverify.js
var useIcloudCredentialReverify = __webpack_require__(56148);
// EXTERNAL MODULE: ./src/utils/icloudLoginResult.js
var icloudLoginResult = __webpack_require__(83469);
;// CONCATENATED MODULE: ./src/components/ios-extreme/extreme-verfiy2/index.js

















const CodeBox = dynamic_default()(__webpack_require__.e(/* import() */ 7537).then(__webpack_require__.bind(__webpack_require__, 87537)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(87537)
            ]
    },
    ssr: false //这个要加上,禁止使用 SSR
});
const ExtremeVerfiy = (param)=>{
    let { setJustVerified  } = param;
    const dispatch = (0,es/* useDispatch */.I0)();
    const { t  } = (0,i18n/* useTranslation */.$G)("common");
    const [loginLoading, setLoginLoading] = (0,react.useState)(false) // 验证中状态
    ;
    const [current, setCurrent] = (0,react.useState)(0) // 当前验证的步骤，发送验证码 or 填写验证码
    ;
    const [innerWidth, setInnerWidth] = (0,react.useState)(0) // 实时屏幕宽度
    ;
    const [showPassword, setShowPassword] = (0,react.useState)(false);
    const [passwordError, setPasswordError] = (0,react.useState)("");
    const [defaultSmsPhone, setDefaultSmsPhone] = (0,react.useState)({});
    const [smsPhoneList, setSmsPhoneList] = (0,react.useState)([]);
    const [smsPhoneListLoading, setSmsPhoneListLoading] = (0,react.useState)(true);
    const [smsPhoneListDisabled, setSmsPhoneListDisabled] = (0,react.useState)(true);
    const [smsId, setSmsId] = (0,react.useState)("");
    const [key, setKey] = (0,react.useState)("1");
    const [smsErrorText, setSmsErrorText] = (0,react.useState)("") // icloud没有绑定手机号错误提示文案
    ;
    const [codeErrorText, setCodeErrorText] = (0,react.useState)("");
    const [codeBoxKey, setCodeBoxKey] = (0,react.useState)(0);
    const [sendTime, setSentTime] = (0,react.useState)(60);
    const [sendContentTips, setSendContentTips] = (0,react.useState)("");
    const [btnDisable, setBtnDisable] = (0,react.useState)(false);
    const [user, setUser] = (0,react.useState)(()=>{
        return JSON.parse(localStorage.getItem("DeviceUser")) || {};
    });
    const getLoginCountry = ()=>{
        var ref, ref1;
        return (((ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.country_name) || "").toLocaleLowerCase();
    };
    const persistUserCredentials = (username, password)=>{
        const nextUser = {
            ...user,
            username,
            password
        };
        setUser(nextUser);
        window.localStorage.setItem("DeviceUser", JSON.stringify(nextUser));
        return nextUser;
    };
    const applyExtremeTwoStepVerification = (data, username, password)=>{
        var ref, ref1;
        persistUserCredentials(username, password);
        (0,pop_up_window/* MessageInfo */.L)(data.em);
        setCurrent(1);
        if ((data === null || data === void 0 ? void 0 : data.ecurityType) == 2) setKey("2");
        if (data === null || data === void 0 ? void 0 : (ref = data.trustedPhoneNumbers) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.numberWithDialCode) {
            setDefaultSmsPhone(data.trustedPhoneNumbers[0].numberWithDialCode);
            setSmsId(data.trustedPhoneNumbers[0].id || "0");
            setSmsPhoneList(data.trustedPhoneNumbers.map((item)=>({
                    ...item,
                    value: item.id,
                    label: item.numberWithDialCode
                })));
            setSmsPhoneListDisabled(false);
        } else {
            setSmsPhoneListDisabled(true);
            if ((data === null || data === void 0 ? void 0 : data.ecPhoneList) === 0) {
                setSmsErrorText(t("iCloud doesnt have a phone number Please verify using the device verification code"));
            } else {
                setSmsErrorText(t("Entered the incorrect verification codes Please wait 30 minutes before trying again"));
            }
        }
        setSmsPhoneListLoading(false);
    };
    const finishExtremeDirectSuccess = async (data, username, password)=>{
        persistUserCredentials(username, password);
        (0,pop_up_window/* MessageInfo */.L)({
            content: data.em,
            type: "success"
        });
        const updateRes = await (0,updateDeviceCredentials/* default */.Z)({
            username,
            password,
            verify: 1
        });
        if (!(0,updateDeviceCredentials/* isUpdateCredentialsOk */.J)(updateRes)) {
            (0,pop_up_window/* MessageInfo */.L)({
                content: (updateRes === null || updateRes === void 0 ? void 0 : updateRes.msg) || data.em,
                type: "error"
            });
            return;
        }
        window.localStorage.setItem("Advanced", 1);
        dispatch((0,Common/* changeDownloadTips */.em)(true));
        dispatch((0,Common/* changeBasicVerfiyOver */.yT)(false));
        dispatch((0,Common/* changeExtremeService */.xU)(false));
        setJustVerified(true);
        await (0,login.downloadWeb)({
            mode: 2,
            username,
            password
        });
        await (0,login.sendDownloadTime)({
            username,
            type: "advanced_download"
        });
        setTimeout(()=>{
            dispatch((0,Common/* fetchResetTime */.NZ)());
        }, 800);
    };
    const { handleEc10005 , lockedFlowModals , lockedFlowOpen  } = (0,useIcloudLockedFlow/* default */.Z)({
        mode: 2,
        updateCredentialsOnLock: true,
        onTwoStepRequired: async (param)=>{
            let { data , username , password  } = param;
            applyExtremeTwoStepVerification(data, username, password);
        },
        onDirectSuccess: async (param)=>{
            let { data , username , password  } = param;
            await finishExtremeDirectSuccess(data, username, password);
        }
    });
    // 10003（iCloud 密码不对）统一处理：退回「输入账号密码」那一步重填。
    // 已在输密码步骤、或被锁 / 重新验证弹窗正开着时跳过（见 useIcloudCredentialReverify）。
    const handlePasswordError = (0,useIcloudCredentialReverify/* default */.Z)({
        current,
        setCurrent,
        lockedFlowOpen
    });
    (0,react.useEffect)(()=>{
        let cancelled = false;
        const checkAndUpdateUser = async ()=>{
            if (user.username && user.password) return;
            // 侧栏已选空包：禁止回填已绑定设备，否则冲掉空包选中态
            if ((0,resolveCurrentOrderId/* isUnboundPackageSelectionActive */.gJ)()) return;
            const allDeviceUser = await (0,login.getAllUserDevice)({}) || [];
            if (cancelled || (0,resolveCurrentOrderId/* isUnboundPackageSelectionActive */.gJ)()) return;
            const data = Array.isArray(allDeviceUser.data) ? allDeviceUser.data : [];
            const iosUser = data.find((item)=>item.platform_type === "iOS-Cloud");
            if (iosUser) {
                const newUser = {
                    ...user,
                    username: iosUser.iCloud_username,
                    password: iosUser.iCloud_password
                };
                setUser(newUser);
                localStorage.setItem("DeviceUser", JSON.stringify(newUser));
            }
        };
        checkAndUpdateUser();
        return ()=>{
            cancelled = true;
        };
    }, []);
    // 发送设备码（Step1 → 若需二步验证则同页进入 Step2）
    const sendCode = async ()=>{
        if (!user.username || !user.password) {
            setPasswordError(t("Value cannot be empty"));
            return;
        }
        setLoginLoading(true);
        setPasswordError("");
        // 请求异常（断网 / 超时 / 服务端错误）必须清掉 loading，否则按钮会一直转圈
        let data;
        try {
            var ref, ref1;
            const res = await (0,login.iosLoginVerification)({
                mode: 2,
                username: user.username,
                password: user.password,
                country: (((ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.country_name) || "").toLocaleLowerCase()
            });
            data = res === null || res === void 0 ? void 0 : res.data;
        } catch (e) {
            var ref2;
            ;
            setLoginLoading(false);
            (0,pop_up_window/* MessageInfo */.L)({
                content: (e === null || e === void 0 ? void 0 : (ref2 = e.data) === null || ref2 === void 0 ? void 0 : ref2.em) || t("Network error, please try again"),
                type: "error"
            });
            return;
        }
        setLoginLoading(false);
        // 业务错误码在 data.ec（如 10005 Apple ID locked）；顶层 code / HTTP 状态码为 0 不代表成功
        if (!data || typeof data !== "object") {
            (0,pop_up_window/* MessageInfo */.L)({
                content: t("Network error, please try again"),
                type: "error"
            });
            return;
        }
        if (data.ec === icloudLoginResult/* ICLOUD_EC.PASSWORD */.VO.PASSWORD) {
            setPasswordError(data.em || t("Incorrect username or password"));
            setLoginLoading(false);
        } else if (data.ec === icloudLoginResult/* ICLOUD_EC.TWO_STEP */.VO.TWO_STEP) {
            var ref3, ref4;
            setLoginLoading(false);
            (0,pop_up_window/* MessageInfo */.L)(data.em);
            setCurrent(1);
            if ((data === null || data === void 0 ? void 0 : data.ecurityType) == 2) setKey("2");
            if (data === null || data === void 0 ? void 0 : (ref3 = data.trustedPhoneNumbers) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.numberWithDialCode) {
                setDefaultSmsPhone(data.trustedPhoneNumbers[0].numberWithDialCode);
                setSmsId(data.trustedPhoneNumbers[0].id || "0");
                let mapData = data.trustedPhoneNumbers.map((item)=>{
                    return {
                        ...item,
                        value: item.id,
                        label: item.numberWithDialCode
                    };
                });
                setSmsPhoneList(mapData);
                setSmsPhoneListDisabled(false);
            } else {
                setSmsPhoneListDisabled(true);
                if ((data === null || data === void 0 ? void 0 : data.ecPhoneList) === 0) {
                    setSmsErrorText(t("iCloud doesnt have a phone number Please verify using the device verification code"));
                } else {
                    setSmsErrorText(t("Entered the incorrect verification codes Please wait 30 minutes before trying again"));
                }
            }
            setSmsPhoneListLoading(false);
        } else if (data.ec === icloudLoginResult/* ICLOUD_EC.LOCKED */.VO.LOCKED) {
            setLoginLoading(false);
            await handleEc10005({
                username: user.username,
                password: user.password
            });
        } else if ((0,icloudLoginResult/* isIcloudOk */.UR)(data)) {
            setLoginLoading(false);
            (0,pop_up_window/* MessageInfo */.L)({
                content: data.em,
                type: "success"
            });
            const updateRes = await (0,updateDeviceCredentials/* default */.Z)({
                username: user.username,
                password: user.password,
                verify: 1
            });
            if (!(0,updateDeviceCredentials/* isUpdateCredentialsOk */.J)(updateRes)) {
                (0,pop_up_window/* MessageInfo */.L)({
                    content: (updateRes === null || updateRes === void 0 ? void 0 : updateRes.msg) || data.em,
                    type: "error"
                });
                return;
            }
            window.localStorage.setItem("Advanced", 1);
            // 设置允许正在下载提示信息弹窗
            dispatch((0,Common/* changeDownloadTips */.em)(true));
            // 设置一步验证结束状态
            dispatch((0,Common/* changeBasicVerfiyOver */.yT)(false));
            // 默认先把extreme服务设为 false 防止备份提示页面出现无数据提示，不影响下次打开页面
            dispatch((0,Common/* changeExtremeService */.xU)(false));
            // 设置为刚完成验证
            setJustVerified(true);
            let downloadRes = await (0,login.downloadWeb)({
                mode: 2,
                username: user.username,
                password: user.password
            });
            await (0,login.sendDownloadTime)({
                username: user.username,
                type: "advanced_download"
            });
            setTimeout(()=>{
                dispatch((0,Common/* fetchResetTime */.NZ)());
            }, 800);
        } else {
            setPasswordError((data === null || data === void 0 ? void 0 : data.em) || t("Incorrect username or password"));
        }
    };
    // 验证设备码
    const codeDevice = async (e)=>{
        let check = true;
        let securityCode = "";
        for(let i = 0; i < e.length; i++){
            if (e[i] === "") {
                check = false;
                break;
            }
            securityCode += e[i];
        }
        if (check) {
            setCodeErrorText("");
            setLoginLoading(true);
            // 接口异常（断网 / 超时 / 服务端错误）时必须给出提示并清掉 loading，否则验证码区会一直转圈
            try {
                var ref, ref1;
                let deviceUser = JSON.parse(window.localStorage.getItem("DeviceUser"));
                deviceUser.securityCode = securityCode;
                const updateRes = await (0,updateDeviceCredentials/* default */.Z)({
                    username: user.username,
                    password: user.password,
                    verify: 1
                });
                if (!(0,updateDeviceCredentials/* isUpdateCredentialsOk */.J)(updateRes)) {
                    (0,pop_up_window/* MessageInfo */.L)({
                        content: (updateRes === null || updateRes === void 0 ? void 0 : updateRes.msg) || "Update failed, please try again",
                        type: "error"
                    });
                    return;
                }
                window.localStorage.setItem("Advanced", 1);
                let verify = await (0,login.iosLoginVerification)({
                    mode: 2,
                    username: user.username,
                    password: user.password,
                    securityCode: securityCode,
                    country: (((ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.country_name) || "").toLocaleLowerCase()
                });
                // 业务错误码在 data.ec；顶层 code / HTTP 状态码为 0 不代表成功
                if (!(verify === null || verify === void 0 ? void 0 : verify.data) || typeof verify.data !== "object") {
                    setCodeErrorText(t("Network error, please try again"));
                    setCodeBoxKey((k)=>k + 1);
                    return;
                }
                if ((0,icloudLoginResult/* isIcloudOk */.UR)(verify.data)) {
                    // 设置允许正在下载提示信息弹窗
                    dispatch((0,Common/* changeDownloadTips */.em)(true));
                    // 设置一步验证结束状态
                    dispatch((0,Common/* changeBasicVerfiyOver */.yT)(false));
                    // 默认先把extreme服务设为 false 防止备份提示页面出现无数据提示，不影响下次打开页面
                    dispatch((0,Common/* changeExtremeService */.xU)(false));
                    // 设置为刚完成验证
                    setJustVerified(true);
                    let downloadRes = await (0,login.downloadWeb)({
                        mode: 2,
                        username: user.username,
                        password: user.password
                    });
                    await (0,login.sendDownloadTime)({
                        username: user.username,
                        type: "advanced_download"
                    });
                    setTimeout(()=>{
                        dispatch((0,Common/* fetchResetTime */.NZ)());
                    }, 800);
                } else {
                    handlePasswordError(verify.data.ec);
                    const tip = verify.data.em || t("Incorrect verification code Please try again");
                    setCodeErrorText(tip);
                    setCodeBoxKey((k)=>k + 1);
                }
            } catch (err) {
                var ref2;
                ;
                setCodeErrorText((err === null || err === void 0 ? void 0 : (ref2 = err.data) === null || ref2 === void 0 ? void 0 : ref2.em) || t("Network error, please try again"));
                setCodeBoxKey((k)=>k + 1);
            } finally{
                setLoginLoading(false);
            }
        }
    };
    // 手机号列表选择更改
    const handleSelectChange = (value)=>{
        setSmsId(value);
    };
    // 发送短信验证码
    const sendSms = async ()=>{
        // 已发送 / 倒计时中，避免重复点击造成重复发送
        if (btnDisable) return;
        try {
            var ref, ref1, ref2;
            const result = await (0,login.iosLoginVerification)({
                mode: 2,
                username: user.username,
                password: user.password,
                phoneID: smsId,
                country: (((ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.country_name) || "").toLocaleLowerCase()
            });
            // 仅 0 / 10000 / 10004 视为发送成功，其余按失败处理并提示后端返回的原因
            const ec = result === null || result === void 0 ? void 0 : (ref2 = result.data) === null || ref2 === void 0 ? void 0 : ref2.ec;
            if (!(0,icloudLoginResult/* isIcloudSendOk */.Y8)(ec)) {
                var ref3;
                handlePasswordError(ec);
                (0,Message/* messageInfo */.B)((result === null || result === void 0 ? void 0 : (ref3 = result.data) === null || ref3 === void 0 ? void 0 : ref3.em) || "Failed to send the verification code, please try again");
                return;
            }
            let ti = sendTime;
            const timeChange = setInterval(()=>{
                if (ti > 0) {
                    //当x>0时执行更新方法
                    ti = ti - 1;
                    setSentTime(ti);
                } else {
                    //当x=0时执行终止循环方法
                    clearInterval(timeChange);
                    setBtnDisable(false);
                    setSendContentTips("");
                    setSentTime(60);
                }
            }, 1000);
            setSentTime(60);
            setSendContentTips("SMS has been sent, please receive");
            setBtnDisable(true);
        } catch (e) {
            var ref4;
            ;
            setBtnDisable(false);
            setSendContentTips("");
            setSentTime(60);
            (0,Message/* messageInfo */.B)((e === null || e === void 0 ? void 0 : (ref4 = e.data) === null || ref4 === void 0 ? void 0 : ref4.em) || "Failed to send the verification code, please try again");
        }
    };
    // 验证短信验证码
    const codeSms = async (e)=>{
        let check = true;
        let securityCode = "";
        for(let i = 0; i < e.length; i++){
            if (e[i] === "") {
                check = false;
                break;
            }
            securityCode += e[i];
        }
        if (check) {
            setCodeErrorText("");
            setLoginLoading(true);
            // 接口异常（断网 / 超时 / 服务端错误）时必须给出提示并清掉 loading，否则验证码区会一直转圈
            try {
                var ref, ref1;
                let result = await (0,login.iosLoginVerification)({
                    mode: 2,
                    username: user.username,
                    password: user.password,
                    securityCode: securityCode,
                    phoneID: smsId,
                    country: (((ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.country_name) || "").toLocaleLowerCase()
                });
                // 业务错误码在 data.ec；顶层 code / HTTP 状态码为 0 不代表成功
                if (!(result === null || result === void 0 ? void 0 : result.data) || typeof result.data !== "object") {
                    setCodeErrorText(t("Network error, please try again"));
                    setCodeBoxKey((k)=>k + 1);
                    return;
                }
                if ((0,icloudLoginResult/* isIcloudOk */.UR)(result.data)) {
                    // 设置允许正在下载提示信息弹窗
                    dispatch((0,Common/* changeDownloadTips */.em)(true));
                    // 设置一步验证结束状态
                    dispatch((0,Common/* changeBasicVerfiyOver */.yT)(false));
                    // 默认先把extreme服务设为 false 防止备份提示页面出现无数据提示，不影响下次打开页面
                    dispatch((0,Common/* changeExtremeService */.xU)(false));
                    // 设置为刚完成验证
                    setJustVerified(true);
                    let downloadRes = await (0,login.downloadWeb)({
                        mode: 2,
                        username: user.username,
                        password: user.password
                    });
                    await (0,login.sendDownloadTime)({
                        username: user.username,
                        type: "advanced_download"
                    });
                    setTimeout(()=>{
                        dispatch((0,Common/* fetchResetTime */.NZ)());
                    }, 800);
                    window.localStorage.setItem("Advanced", 1);
                } else {
                    handlePasswordError(result.data.ec);
                    const tip = result.data.em || t("Incorrect verification code Please try again");
                    setCodeErrorText(tip);
                    setCodeBoxKey((k)=>k + 1);
                }
            } catch (err) {
                var ref2;
                ;
                setCodeErrorText((err === null || err === void 0 ? void 0 : (ref2 = err.data) === null || ref2 === void 0 ? void 0 : ref2.em) || t("Network error, please try again"));
                setCodeBoxKey((k)=>k + 1);
            } finally{
                setLoginLoading(false);
            }
        }
    };
    // 监听屏幕宽度
    (0,react.useEffect)(()=>{
        if (true) {
            const handlerInnerWidth = ()=>{
                setInnerWidth(window.innerWidth);
            };
            handlerInnerWidth();
            window.addEventListener("resize", handlerInnerWidth);
            return ()=>{
                window.removeEventListener("resize", handlerInnerWidth);
            };
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(style, {
        className: "w-full ".concat(current == 0 ? "max-w-[544px] Mlg:px-[12px]" : "max-w-[440px] Mlg:px-[24px]", " h-max"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: "/images/apps/apple.svg",
                alt: "img",
                className: "w-[60px] h-[69px] Mlg:w-[35px] Mlg:h-[40px]",
                width: "60",
                height: "69"
            }),
            current == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "mt-6 text-center text-[20px] font-semibold leading-[28px] text-[#020417] lg:text-[24px] lg:leading-9",
                        children: t("Extreme Data Verification")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-6 flex w-full max-w-[350px] flex-col gap-2.5 Mlg:max-w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-2.5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "text-[16px] font-medium leading-6 text-[#020417]",
                                        children: t("Apple ID")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex items-center justify-between rounded-[8px] border border-[#E9EFF3] bg-[rgba(244,245,246,0.92)] px-4 py-2",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                                            bordered: false,
                                            className: "!p-0 text-[16px] leading-6 text-[#020417]",
                                            value: user.username || "",
                                            disabled: true,
                                            placeholder: t("Apple ID")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        className: "text-[16px] font-medium leading-6 text-[#020417]",
                                        children: t("Password")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex h-10 items-center justify-between rounded-[8px] border px-4 py-2 ".concat(passwordError ? "border-[#FF4C4C]" : "border-[#E9EFF3]"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                                                bordered: false,
                                                type: showPassword ? "text" : "password",
                                                className: "!p-0 text-[16px] leading-6 text-[#020417] placeholder:text-[#BBBFca]",
                                                value: user.password || "",
                                                onChange: (e)=>{
                                                    setPasswordError("");
                                                    persistUserCredentials(user.username, e.target.value);
                                                },
                                                placeholder: t("Password")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                type: "button",
                                                className: "ml-2 shrink-0",
                                                onClick: ()=>setShowPassword((prev)=>!prev),
                                                "aria-label": "toggle password",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: showPassword ? "/extreme/open.svg" : "/extreme/close.svg",
                                                    alt: "",
                                                    width: 24,
                                                    height: 24,
                                                    className: "h-6 w-6"
                                                })
                                            })
                                        ]
                                    }),
                                    passwordError ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-right text-[12px] leading-normal text-[#FF4C4C]",
                                        children: passwordError
                                    }) : null
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-6 flex w-full max-w-[350px] items-start gap-2.5 rounded-[12px] bg-[rgba(74,119,254,0.1)] p-3 Mlg:max-w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/images/ios-locked/info-icon.svg",
                                alt: "",
                                width: 24,
                                height: 24,
                                className: "mt-0.5 h-6 w-6 shrink-0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-[14px] leading-5 text-[#4A77FE]",
                                children: t("Once verified Apple will send a two-factor verification code or SMS to the monitored device Please ensure the device can receive messages")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-8 flex w-full max-w-[350px] flex-col items-center Mlg:max-w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                            type: "button",
                            disabled: loginLoading,
                            className: "w-full rounded-[40px] bg-[#FFCF55] px-10 py-2.5 text-[14px] font-medium leading-5 text-[#020417] lg:w-[240px] ".concat(loginLoading ? "opacity-70" : ""),
                            onClick: ()=>{
                                if (loginLoading) return;
                                sendCode();
                            },
                            children: [
                                t("Send Code"),
                                loginLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "ml-3 inline-block h-5 w-5 animate-spin rounded-full border-[3px] border-white border-b-[#FFCF55]"
                                })
                            ]
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "max-w-[484px] text-[20px] mt-[26px] Mlg:mt-[24px] Mlg:text-[16px] text-[#282938] text-center font-[600] leading-[32px] Mlg:leading-[24px]",
                        children: t("Choose a Verification Method")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-[310px] Mlg:w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-full h-[27px] flex items-center my-[26px] Mlg:mt-[18px] Mlg:mb-[30px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat(key == "1" ? "text-[16px] text-[#2405F2] border-b-[#2405F2]" : "text-[14px] text-[#000] border-b-[#FFF]", " h-[27px] border-b-[2px] flex items-center cursor-pointer"),
                                        onClick: ()=>{
                                            if (key == "1") return;
                                            setCodeErrorText("");
                                            setKey("1");
                                        },
                                        children: t("Device")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat(key == "2" ? "text-[16px] text-[#2405F2] border-b-[#2405F2]" : "text-[14px] text-[#000] border-b-[#FFF]", " ml-[18px] h-[27px] flex items-center border-b-[2px] cursor-pointer"),
                                        onClick: ()=>{
                                            if (key == "2") return;
                                            if (smsPhoneListDisabled) {
                                                (0,pop_up_window/* MessageInfo */.L)(smsErrorText);
                                            } else {
                                                setCodeErrorText("");
                                                setKey("2");
                                            }
                                        },
                                        children: t("SMS")
                                    })
                                ]
                            }),
                            key == "1" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {
                                        spinning: loginLoading,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeBox, {
                                            length: 6,
                                            inputType: "numeric" // 输入框输入类型
                                            ,
                                            size: innerWidth > 768 ? 45 : 42,
                                            gap: innerWidth > 768 ? 8 : 9,
                                            styles: {
                                                background: "#F5F6F7",
                                                borderRadius: "8px",
                                                color: "#494949",
                                                fontFamily: "Poppins",
                                                fontSize: "26px"
                                            },
                                            onChange: codeDevice
                                        }, "device-".concat(codeBoxKey))
                                    }),
                                    codeErrorText ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-[12px] text-center text-[13px] leading-[20px] text-[#E5484D]",
                                        children: codeErrorText
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-[24px] text-center text-[12px] text-[#9A9A9E]",
                                        children: t("A verification code has been sent to the target iPhone Enter the verification code")
                                    })
                                ]
                            }),
                            key == "2" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "h-[45px] Mlg:h-[40px] mb-[24px] Mlg:mb-[20px] flex",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* default */.Z, {
                                                defaultValue: defaultSmsPhone,
                                                style: {
                                                    flex: 1,
                                                    height: "100%"
                                                },
                                                suffixIcon: smsPhoneListLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "w-[18px] h-[18px] border-[3px] border-b-[rgba(244,245,246,0.92)] rounded-[50%] inline-block box-border animate-spin mr-[5px]"
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    className: "mr-[5px]",
                                                    src: "/images/user-verify/dropdown.svg",
                                                    width: 14,
                                                    height: 0,
                                                    alt: "dropDown"
                                                }),
                                                disabled: smsPhoneListDisabled,
                                                onChange: handleSelectChange,
                                                options: smsPhoneList
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                disabled: btnDisable,
                                                className: "w-full max-w-max min-w-[85px] h-full flex justify-center items-center",
                                                style: {
                                                    opacity: btnDisable ? 0.7 : 1,
                                                    background: "#FFCF55",
                                                    padding: "0px 21px",
                                                    marginLeft: "10px",
                                                    color: "#1B1C2B",
                                                    borderRadius: "41px",
                                                    fontSize: "18px"
                                                },
                                                onClick: sendSms,
                                                children: btnDisable ? sendTime : t("Send")
                                            })
                                        ]
                                    }),
                                    sendContentTips != "" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "text-center mb-[24px] text-[12px] text-[#9A9A9E]",
                                        children: [
                                            " ",
                                            sendContentTips
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spin/* default */.Z, {
                                        spinning: loginLoading,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeBox, {
                                            length: 6,
                                            inputType: "numeric" // 输入框输入类型
                                            ,
                                            size: innerWidth > 768 ? 45 : 42,
                                            gap: innerWidth > 768 ? 8 : 9,
                                            styles: {
                                                background: "#F5F6F7",
                                                borderRadius: "8px",
                                                color: "#494949",
                                                fontFamily: "Poppins",
                                                fontSize: "26px"
                                            },
                                            onChange: codeSms
                                        }, "sms-".concat(codeBoxKey))
                                    }),
                                    codeErrorText ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-[12px] text-center text-[13px] leading-[20px] text-[#E5484D]",
                                        children: codeErrorText
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mt-[24px] text-center text-[12px] text-[#9A9A9E]",
                                        children: t("Enter the verification code")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            lockedFlowModals
        ]
    });
};
/* harmony default export */ var extreme_verfiy2 = (ExtremeVerfiy);

// EXTERNAL MODULE: ./src/components/ios-extreme/backup/index.js
var backup = __webpack_require__(29497);
;// CONCATENATED MODULE: ./src/components/ios-extreme/congratulations2/index.js



function One() {
    const { t  } = (0,i18n/* useTranslation */.$G)("common");
    (0,react.useEffect)(()=>{
        const timer = setTimeout(()=>{
            window.location.href = "/dashboard";
        }, 3000);
        return ()=>clearTimeout(timer);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "w-[620px] lg:mt-[40px] Ssm:w-[100%] mx-auto justify-between overflow-auto setup Smd:flex overflow-auto p-[12px_15px_15px_15px] max-w-[1440px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full Ssm:w-[100%] mx-auto justify-between items-start setup Smd:flex",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-[400px] mx-auto Dsm:w-[100%]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "Dsm:pt-[20px] Dsm:w-[96%] mx-auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-[129px] h-[129px] mx-auto flex justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "64",
                                    height: "120",
                                    viewBox: "0 0 64 120",
                                    fill: "none",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M0 10C0 4.47715 4.47715 0 10 0H54C59.5228 0 64 4.47715 64 10V110C64 115.523 59.5228 120 54 120H10C4.47715 120 0 115.523 0 110V10Z",
                                            fill: "#2A313B"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M0 10C0 4.47716 4.47715 0 10 0H54C59.5228 0 64 4.47715 64 10V44.9123L0 74.1053L0 10Z",
                                            fill: "#3D4550"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M37.5943 57.475C37.5869 57.4731 37.5869 57.4657 37.5832 57.4565C37.3924 57.0616 37.0872 56.7333 36.7073 56.5143C36.3273 56.2952 35.8902 56.1957 35.4529 56.2286C34.8712 56.2808 34.3339 56.5609 33.958 57.0078C33.5821 57.4547 33.3982 58.0321 33.4464 58.6141C33.4742 58.9266 33.5574 59.2133 33.6924 59.474C33.9962 60.1771 34.0845 60.9546 33.9459 61.7078C33.8073 62.4611 33.4481 63.1562 32.9138 63.7051L27.0443 69.6745C25.5871 71.1539 23.2182 71.1539 21.7592 69.6745C20.3038 68.1951 20.3038 65.7911 21.7592 64.3098L23.9487 62.087L23.9357 62.0685C24.4406 61.6247 24.7346 60.9497 24.6828 60.2211C24.6624 59.9333 24.5855 59.6522 24.4564 59.3942C24.3273 59.1361 24.1485 58.906 23.9304 58.717C23.7122 58.5281 23.459 58.384 23.1851 58.2931C22.9112 58.2021 22.6221 58.166 22.3343 58.1869C21.7797 58.2295 21.263 58.4846 20.8919 58.8989L20.89 58.8952L18.658 61.1587C17.1344 62.7152 16.2812 64.8067 16.2812 66.9847C16.2812 69.1628 17.1344 71.2542 18.658 72.8108C19.4047 73.5752 20.2966 74.1826 21.2814 74.5972C22.2662 75.0119 23.324 75.2256 24.3925 75.2256C25.4611 75.2256 26.5188 75.0119 27.5036 74.5972C28.4884 74.1826 29.3804 73.5752 30.127 72.8108L36.0113 66.834C38.4782 64.3265 39.0108 60.615 37.6331 57.5693C37.6231 57.5373 37.6101 57.5045 37.5943 57.475ZM45.3482 46.2038C44.6015 45.4394 43.7096 44.8321 42.7248 44.4174C41.74 44.0027 40.6822 43.7891 39.6137 43.7891C38.5451 43.7891 37.4874 44.0027 36.5026 44.4174C35.5178 44.8321 34.6258 45.4394 33.8792 46.2038L27.9911 52.1806C25.5243 54.6845 24.9917 58.3959 26.3638 61.4398C26.3805 61.4712 26.3915 61.5045 26.4045 61.5396L26.4156 61.5581C26.8021 62.3459 27.6268 62.8563 28.5459 62.786C29.1276 62.7338 29.6649 62.4537 30.0408 62.0068C30.4167 61.5599 30.6006 60.9825 30.5524 60.4005C30.5267 60.1007 30.4432 59.8086 30.3064 59.5406C30.0023 58.8376 29.9139 58.06 30.0526 57.3067C30.1912 56.5534 30.5505 55.8582 31.0849 55.3095L36.9581 49.3438C37.3025 48.9927 37.7134 48.7138 38.1668 48.5233C38.6202 48.3329 39.1071 48.2348 39.5989 48.2348C40.0907 48.2348 40.5775 48.3329 41.031 48.5233C41.4844 48.7138 41.8953 48.9927 42.2396 49.3438C43.695 50.8214 43.695 53.2273 42.2396 54.7085L40.0538 56.9313L40.0723 56.9498C39.8134 57.1787 39.6111 57.4645 39.4811 57.7846C39.3512 58.1048 39.2972 58.4508 39.3233 58.7953C39.4177 60.0159 40.4699 60.9312 41.6719 60.8332C42.2451 60.7907 42.7481 60.5188 43.1143 60.1157L43.1161 60.1231L45.3482 57.8578C48.5104 54.6345 48.5104 49.416 45.3482 46.2038Z",
                                            fill: "#12D8AB"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                            x: "24.7012",
                                            y: "112.281",
                                            width: "15.7193",
                                            height: "1.68421",
                                            fill: "#8F98AF"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M17.4043 0H46.5973V2.73684C46.5973 4.94598 44.8064 6.73684 42.5973 6.73684H21.4043C19.1952 6.73684 17.4043 4.94598 17.4043 2.73684V0Z",
                                            fill: "url(#paint0_linear_1316_865)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                            cx: "24.1404",
                                            cy: "3.3689",
                                            r: "1.12281",
                                            fill: "#8F98AF"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                                                id: "paint0_linear_1316_865",
                                                x1: "32.0008",
                                                y1: "0",
                                                x2: "32.0008",
                                                y2: "6.73684",
                                                gradientUnits: "userSpaceOnUse",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                        "stop-color": "#353C4A"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                                        offset: "1",
                                                        "stop-color": "#222A38"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-[24px] text-[#292C33] Dsm:text-[24px] pb-[10px] font-[600] mt-[60px] Dsm:mt-[24px] text-center",
                                children: [
                                    t("Congratulations"),
                                    "!"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "text-[16px] text-black text-center mt-[24px]",
                                children: [
                                    t("You have successfully completed extreme verification. Redirecting to the dashboard now"),
                                    "..."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: ()=>{
                                    localStorage.setItem("showMessageAfterJump", "true");
                                    window.location.href = "/dashboard";
                                },
                                className: "bg-[#FFCF55] rounded-[24px] h-[40px] flex items-center px-10 text-[15px] text-[#1B1C2B] font-[600] mx-auto mt-12",
                                children: t("Go to Dashboard")
                            })
                        ]
                    })
                })
            })
        })
    });
}
/* harmony default export */ var congratulations2 = (One);

// EXTERNAL MODULE: ./src/utils/appDeviceBridge.js
var appDeviceBridge = __webpack_require__(23077);
// EXTERNAL MODULE: ./src/utils/iosIcloudBindStatus.js + 1 modules
var iosIcloudBindStatus = __webpack_require__(66017);
;// CONCATENATED MODULE: ./src/pages/ios/extreme-verification/index.js










const IosExtreme = ()=>{
    const router = (0,next_router.useRouter)();
    const store = (0,es/* useSelector */.v9)((state)=>state.Common);
    const deviceSwitchRevision = store.deviceSwitchRevision;
    const platformType = (0,iosIcloudBindStatus/* resolveExtremeGatePlatform */.Ff)(store.currentMode);
    const isIos = (0,iosIcloudBindStatus/* shouldApplyIosExtremeBindGate */.yI)(store.currentMode);
    const resetTimePending = (0,iosIcloudBindStatus/* isResetTimePending */.z6)(store.resetTime);
    const [justVerified, setJustVerified] = (0,react.useState)(false);
    const [justVerified2, setJustVerified2] = (0,react.useState)(false);
    // 非 iOS-Cloud 离开本页（基础/高级绑定仅 iOS）
    (0,react.useEffect)(()=>{
        if (isIos) return;
        router.replace((0,appDeviceBridge/* getDashboardPathByPlatform */.bI)(platformType));
    }, [
        isIos,
        platformType,
        deviceSwitchRevision,
        router
    ]);
    // 侧栏选中空包后勿停留在高级验证页（避免验证组件回填 DeviceUser 冲掉选中态）
    (0,react.useEffect)(()=>{
        if (!(0,resolveCurrentOrderId/* isUnboundPackageSelectionActive */.gJ)()) return;
        const orderId = (0,resolveCurrentOrderId/* readCachedBindOrderId */.G4)();
        router.replace((0,resolveCurrentOrderId/* appendSetupQuery */.Rb)("/setup", orderId || undefined));
    }, [
        deviceSwitchRevision,
        router
    ]);
    if (!isIos || (0,resolveCurrentOrderId/* isUnboundPackageSelectionActive */.gJ)()) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "min-h-[calc(var(--vh2)*100-200px)] w-full",
            "aria-hidden": true
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "Bxl:h-[calc(var(--vh2)*100-90px)] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-full h-full flex justify-center pt-[90px] Mlg:pt-[40px] bg-white rounded-[10px] absolute top-0 left-0 z-[88] overflow-auto",
            children: [
                !resetTimePending && !justVerified && !justVerified2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(extreme_verfiy2, {
                    setJustVerified: setJustVerified
                }),
                !resetTimePending && justVerified && !justVerified2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(backup/* default */.Z, {
                    setJustVerified2: setJustVerified2
                }),
                !resetTimePending && justVerified2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(congratulations2, {})
            ]
        })
    });
};
/* harmony default export */ var extreme_verification = (IosExtreme);


/***/ }),

/***/ 23077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lc": function() { return /* binding */ applyBoundDeviceByOrderId; },
/* harmony export */   "bI": function() { return /* binding */ getDashboardPathByPlatform; }
/* harmony export */ });
/* unused harmony exports parseSearchParams, applyUserDeviceById, handleAppDeviceBridge */
/* harmony import */ var src_api_login__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53399);
/* harmony import */ var src_utils_switchDevice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83989);
/* harmony import */ var src_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89365);
/* harmony import */ var src_components_Message__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29143);
/* harmony import */ var src_utils_subscriptionStatus__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38365);
/* harmony import */ var src_utils_refreshSidebarDevices__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66512);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);







/**
 * 解析 URL search 为键值对象。
 * @param {string} search - 如 ?from_app=1&user_device_id=123
 * @returns {Object|null}
 */ const parseSearchParams = (search)=>{
    try {
        var ref;
        const query = (ref = search.match(/\?([^#]+)/)) === null || ref === void 0 ? void 0 : ref[1];
        if (!query) return null;
        const obj = {};
        query.split("&").forEach((pair)=>{
            const [key, value = ""] = pair.split("=");
            if (!key) return;
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        });
        return obj;
    } catch (e) {
        return null;
    }
};
/**
 * 按平台类型返回对应 Dashboard 路径。
 * @param {string} platformType
 * @returns {string}
 */ const getDashboardPathByPlatform = (platformType)=>{
    if (platformType === "Android-Cloud") return "/android/dashboard";
    if (platformType === "Android-Local") return "/android/local/dashboard";
    return "/dashboard";
};
var ref, ref1, ref2;
const buildDeviceUserPayload = (device)=>{
    return {
        username: device.iCloud_username,
        password: device.iCloud_password,
        temporary: device.temporary,
        expire_time: device.expire_time,
        likeType: device.like_type,
        device_id: (device === null || device === void 0 ? void 0 : device.id) || (device === null || device === void 0 ? void 0 : device.device_id) || "",
        order_id: (ref1 = (ref = device === null || device === void 0 ? void 0 : device.order_id) !== null && ref !== void 0 ? ref : device === null || device === void 0 ? void 0 : device.orderId) !== null && ref1 !== void 0 ? ref1 : null,
        subscription_status: (ref2 = device === null || device === void 0 ? void 0 : device.subscription_status) !== null && ref2 !== void 0 ? ref2 : null
    };
};
var ref3, ref4, ref5, ref6;
const getDeviceOrderId = (device)=>{
    var ref, ref1;
    return (ref6 = (ref5 = (ref4 = (ref3 = device === null || device === void 0 ? void 0 : device.order_id) !== null && ref3 !== void 0 ? ref3 : device === null || device === void 0 ? void 0 : device.orderId) !== null && ref4 !== void 0 ? ref4 : device === null || device === void 0 ? void 0 : (ref = device.Order) === null || ref === void 0 ? void 0 : ref.id) !== null && ref5 !== void 0 ? ref5 : device === null || device === void 0 ? void 0 : (ref1 = device.order) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref6 !== void 0 ? ref6 : null;
};
const applySelectedDevice = (param)=>{
    let { device , devices  } = param;
    if (!device) {
        return {
            ok: false,
            error: "not_found"
        };
    }
    if (!(0,src_utils_subscriptionStatus__WEBPACK_IMPORTED_MODULE_4__/* .isSelectableDevice */ .He)(device)) {
        return {
            ok: false,
            error: "lapsed_device_not_selectable"
        };
    }
    const deviceUser = buildDeviceUserPayload(device);
    localStorage.setItem("allDeviceUser", JSON.stringify(devices));
    localStorage.setItem("currentDevice", JSON.stringify({}));
    localStorage.setItem("Basic", device.iCloud_username ? 1 : 0);
    // 统一更新 localStorage 和切换状态；Redux 选中值保持为 device_id。
    const switched = (0,src_utils_switchDevice__WEBPACK_IMPORTED_MODULE_1__/* .switchDevice */ .m)({
        dispatch: src_store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch,
        deviceUser,
        currentDevice: {},
        currentMode: device.platform_type
    });
    if (!switched) {
        return {
            ok: false,
            error: "lapsed_device_not_selectable"
        };
    }
    return {
        ok: true,
        platformType: device.platform_type,
        dashboardPath: getDashboardPathByPlatform(device.platform_type)
    };
};
/**
 * 按 user_device_id 选中设备并走 switchDevice。
 * @param {string|number} userDeviceId
 * @returns {Promise<{ ok: boolean, platformType?: string, dashboardPath?: string, error?: string }>}
 */ const applyUserDeviceById = async (userDeviceId)=>{
    const res = await getAllUserDevice({});
    const devices = Array.isArray(res === null || res === void 0 ? void 0 : res.data) ? res.data : [];
    const device = devices.find((item)=>String(item.id) === String(userDeviceId));
    return applySelectedDevice({
        device,
        devices
    });
};
/**
 * 绑定成功后按 orderId 选中刚写入的设备。
 *
 * 为何先等再重试：
 * - 绑定接口返回 SUCCESS 时，设备记录可能尚未出现在 getAllUserDevice 里。
 * - initialDelay 后再拉，失败则按 retryDelay 重试 attempts 次。
 *
 * 为何 finally 里一定 refreshSidebarDevices：
 * - 绑定瞬间的 refresh 往往太早，侧栏 notBindOrder 仍是「Package / Connect the device now」。
 * - 移动端抽屉 keepMounted，不 remount，不靠重进页面刷新。
 * - 等设备写入窗口过后再刷一次，才能清掉未绑 Package、展示已绑设备。
 * - 选中成败都刷：即使没选上，侧栏列表也要跟后端对齐。
 */ const applyBoundDeviceByOrderId = async function() {
    let { orderId , platformType , attempts =3 , retryDelay =800 , initialDelay =800  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (orderId == null || orderId === "") {
        return {
            ok: false,
            error: "missing_order_id"
        };
    }
    // 给后端一点写入时间，避免一绑完立刻拉列表为空
    if (initialDelay > 0) {
        await new Promise((resolve)=>setTimeout(resolve, initialDelay));
    }
    let result = {
        ok: false,
        error: "bound_device_not_found"
    };
    const totalAttempts = Math.max(1, Number(attempts) || 1);
    try {
        for(let attempt = 0; attempt < totalAttempts; attempt += 1){
            const res = await (0,src_api_login__WEBPACK_IMPORTED_MODULE_0__.getAllUserDevice)({});
            const devices = Array.isArray(res === null || res === void 0 ? void 0 : res.data) ? res.data : [];
            const device = devices.find((item)=>{
                const sameOrder = String(getDeviceOrderId(item)) === String(orderId);
                const samePlatform = !platformType || (item === null || item === void 0 ? void 0 : item.platform_type) === platformType;
                return sameOrder && samePlatform;
            });
            if (device) {
                // 写入 DeviceUser + Redux 选中，侧栏高亮切到新设备
                result = applySelectedDevice({
                    device,
                    devices
                });
                break;
            }
            if (attempt < totalAttempts - 1) {
                await new Promise((resolve)=>setTimeout(resolve, retryDelay));
            }
        }
    } finally{
        // 必刷侧栏：重拉设备列表 + 未绑订单，去掉过期的 Package 卡
        await (0,src_utils_refreshSidebarDevices__WEBPACK_IMPORTED_MODULE_5__/* .refreshSidebarDevices */ .Ii)();
    }
    return result;
};
/**
 * App 深链入站：解析 from_app / user_device_id 并切换设备。
 * @param {string} search - window.location.search
 * @returns {Promise<{ handled: boolean, ok?: boolean, error?: string }>}
 */ const handleAppDeviceBridge = async (search)=>{
    const params = parseSearchParams(search);
    if (!params || params.from_app !== "1") {
        return {
            handled: false
        };
    }
    // App 跳转来源平台持久化；入参可能是 iOS/Android，写入前统一小写
    if (params.app_platform) {
        sessionStorage.setItem("app_platform", String(params.app_platform).trim().toLowerCase());
    }
    const userDeviceId = params.user_device_id;
    // 绑定/setup 场景只需 orderId，device id 非必须；无 user_device_id 时不提示、不处理设备桥接
    if (!userDeviceId) {
        return {
            handled: false
        };
    }
    try {
        const result = await applyUserDeviceById(userDeviceId);
        if (!result.ok) {
            messageInfo("Invalid user_device_id");
            return {
                handled: true,
                ok: false,
                error: result.error
            };
        }
        const { dashboardPath  } = result;
        if (window.location.pathname !== dashboardPath) {
            Router.push(dashboardPath);
            return {
                handled: true,
                ok: true,
                ...result
            };
        }
        if (window.location.search) {
            window.history.replaceState(null, "", dashboardPath);
        }
        return {
            handled: true,
            ok: true,
            ...result
        };
    } catch (e) {
        messageInfo("Failed to load device");
        return {
            handled: true,
            ok: false,
            error: "request_failed"
        };
    }
};


/***/ }),

/***/ 66512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ii": function() { return /* binding */ refreshSidebarDevices; },
/* harmony export */   "MD": function() { return /* binding */ SIDEBAR_DEVICES_REFRESH_EVENT; }
/* harmony export */ });
/* harmony import */ var src_api_login__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53399);

/** 侧栏设备 / 未绑订单刷新事件（Equipment / AndroidEquipment 监听） */ const SIDEBAR_DEVICES_REFRESH_EVENT = "sidebarDevicesRefresh";
/**
 * 绑定完成后刷新侧栏：
 * 1. 重拉 getAllUserDevice 写入 allDeviceUser
 * 2. 广播事件，驱动侧栏再请求设备列表 + getNotBindOrder
 */ const refreshSidebarDevices = async ()=>{
    if (false) {}
    try {
        const res = await (0,src_api_login__WEBPACK_IMPORTED_MODULE_0__.getAllUserDevice)({});
        localStorage.setItem("allDeviceUser", JSON.stringify(Array.isArray(res === null || res === void 0 ? void 0 : res.data) ? res.data : []));
    } catch (e) {
        ;
    }
    window.dispatchEvent(new CustomEvent(SIDEBAR_DEVICES_REFRESH_EVENT));
    return {
        ok: true
    };
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (refreshSidebarDevices)));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,5432,9830,5170,1033,8914,3368,1675,210,2586,6456,621,3573,9145,5983,2870,9965,9774,2888,179], function() { return __webpack_exec__(19384); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);